import React from 'react'
import Browse from '../component/Browse'

const TvShow = () => {
  return (
    <div>
        <Browse path="tvShow"/>
    </div>
  )
}

export default TvShow